function findRealItem(meeting, jsonId) {
    const item = meeting['items'].find(item => item.agid === `${jsonId}`)
    return item
}

export default findRealItem